export const filterHelper = {
  mapFacetValues
}

function mapFacetValues ({ values, facet, urlFacets, checkedFacets }) {
  const facetData = values.map((facetValues) => { return { ...facetValues, isChecked: false, facetQuery: null, facet } })
  if (urlFacets != null) {
    if(Object.keys(urlFacets).length > 0) {
      let mappedFacets = []
      Object.keys(urlFacets).forEach((key) => {
        if (key.includes('refinementList=')) {
          const facet = key.split('=')[1]
          const facetData = urlFacets[key].split('~').map((val) => ({
            value: val,
            count: 1,
            isChecked: true,
            facetQuery: null,
            facet: facet
          }))
          facetData.forEach(({ value }) => {
            mappedFacets.push({ facet, value })
          })
        }
      })
      mappedFacets.forEach((oldFacetValues) => {
        const index = facetData.findIndex(({ value, facet }) => {
          return oldFacetValues.value === value && facet === oldFacetValues.facet
        })
        if (index >= 0) {
          facetData[index] = { ...facetData[index], isChecked: true }
        }
      })
    }
  }  else if (checkedFacets != null) {
    checkedFacets = checkedFacets.filter(({ isChecked }) => isChecked)
    checkedFacets.forEach((oldFacetValues) => {
      const index = facetData.findIndex(({ value, facet }) => {
        return oldFacetValues.value === value && facet === oldFacetValues.facet
      })
      if (index >= 0) {
        facetData[index] = { ...facetData[index], isChecked: true }
      } else {
        facetData.push(oldFacetValues)
      }
    })
  }
  facetData.sort((a, b) => b.isChecked - a.isChecked)
  return { facet, facetData: facetData }
}
